import type { AlertItem } from "@queueryte/contracts";

export type AlertFilter = AlertItem["status"];
export const alertFilters: ReadonlyArray<readonly [AlertFilter, string]> = [["open", "Open"], ["acknowledged", "Acknowledged"], ["recovered", "Recovered"]];

/** Alerts nobody has responded to yet. This is the number that asks for attention. */
export const openAlertCount = (alerts: AlertItem[]): number => alerts.filter((alert) => alert.status === "open").length;

/** Alerts that are still happening: open or acknowledged, but not recovered. */
export const activeAlerts = (alerts: AlertItem[]): AlertItem[] => alerts.filter((alert) => alert.status !== "recovered");

export const alertsWithStatus = (alerts: AlertItem[], status: AlertFilter): AlertItem[] => alerts.filter((alert) => alert.status === status);
